import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export const generatePDF = async (element, filename = 'resume.pdf') => {
  try {
    console.log("Starting PDF generation...");
    
    // Show loading indicator
    const loadingIndicator = document.createElement('div');
    loadingIndicator.style.cssText = `
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: rgba(0,0,0,0.8);
      color: white;
      padding: 20px 40px;
      border-radius: 10px;
      z-index: 9999;
      font-family: Arial, sans-serif;
    `;
    loadingIndicator.innerHTML = '🔄 Generating PDF...';
    document.body.appendChild(loadingIndicator);

    // Get element dimensions
    const originalWidth = element.offsetWidth;
    const originalHeight = element.offsetHeight;
    
    // Create a clone to avoid affecting the original
    const clone = element.cloneNode(true);
    clone.style.cssText = `
      position: fixed;
      left: -10000px;
      top: 0;
      width: ${originalWidth}px;
      height: ${originalHeight}px;
      background: white;
      padding: 40px;
      box-sizing: border-box;
    `;
    
    // Temporarily add clone to DOM
    document.body.appendChild(clone);

    const canvas = await html2canvas(clone, {
      scale: 3, // Higher scale for better quality
      useCORS: true,
      logging: false,
      backgroundColor: '#ffffff',
      removeContainer: true,
      windowWidth: originalWidth,
      windowHeight: originalHeight,
      onclone: (clonedDoc) => {
        // Ensure all fonts are loaded
        const style = clonedDoc.createElement('style');
        style.innerHTML = `
          @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
          * {
            font-family: 'Inter', sans-serif !important;
          }
        `;
        clonedDoc.head.appendChild(style);
      }
    });

    // Remove clone
    document.body.removeChild(clone);
    
    const imgData = canvas.toDataURL('image/png', 1.0);
    const pdf = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a4',
      compress: true
    });

    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    
    // Calculate dimensions to fit A4
    const imgWidth = pageWidth - 40; // 20mm margin on each side
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    
    let heightLeft = imgHeight;
    let position = 20; // Top margin
    
    pdf.addImage(imgData, 'PNG', 20, position, imgWidth, imgHeight);
    heightLeft -= (pageHeight - 40);
    
    // Add more pages if needed
    while (heightLeft > 0) {
      position = -heightLeft + 20;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 20, position, imgWidth, imgHeight);
      heightLeft -= (pageHeight - 40);
    }
    
    // Remove loading indicator
    document.body.removeChild(loadingIndicator);
    
    // Show success message
    const successMsg = document.createElement('div');
    successMsg.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: linear-gradient(135deg, #10b981, #059669);
      color: white;
      padding: 15px 30px;
      border-radius: 10px;
      z-index: 9999;
      font-family: Arial, sans-serif;
      animation: slideIn 0.3s ease-out;
    `;
    successMsg.innerHTML = '✅ PDF Downloaded Successfully!';
    document.body.appendChild(successMsg);
    
    setTimeout(() => {
      document.body.removeChild(successMsg);
    }, 3000);
    
    pdf.save(filename);
    return true;
    
  } catch (error) {
    console.error('Error generating PDF:', error);
    
    // Show error message
    const errorMsg = document.createElement('div');
    errorMsg.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: linear-gradient(135deg, #ef4444, #dc2626);
      color: white;
      padding: 15px 30px;
      border-radius: 10px;
      z-index: 9999;
      font-family: Arial, sans-serif;
      animation: slideIn 0.3s ease-out;
    `;
    errorMsg.innerHTML = '❌ Failed to generate PDF. Please try again.';
    document.body.appendChild(errorMsg);
    
    setTimeout(() => {
      document.body.removeChild(errorMsg);
    }, 3000);
    
    throw error;
  }
};

// Alternative method using direct HTML to PDF
export const generatePDFFromHTML = async (htmlContent, filename = 'resume.pdf') => {
  const pdf = new jsPDF({
    orientation: 'portrait',
    unit: 'mm',
    format: 'a4',
  });

  // Add custom font (optional)
  pdf.setFont('helvetica');
  
  // Split content into pages
  const lines = pdf.splitTextToSize(htmlContent, 180);
  let y = 20;
  
  for (let i = 0; i < lines.length; i++) {
    if (y > 270) {
      pdf.addPage();
      y = 20;
    }
    pdf.text(lines[i], 20, y);
    y += 10;
  }
  
  pdf.save(filename);
  return true;
};